import { render, staticRenderFns } from "./SelectRadio.vue?vue&type=template&id=20c875cf&scoped=true"
import script from "./SelectRadio.vue?vue&type=script&lang=js"
export * from "./SelectRadio.vue?vue&type=script&lang=js"
import style0 from "./SelectRadio.vue?vue&type=style&index=0&id=20c875cf&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c875cf",
  null
  
)

export default component.exports